export default "__VITE_ASSET__D1m7lLiH__"